import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BackIcon, EXLDownloadIcon, RightArrowIcon } from "../assets/Icons";
import UserResponseList from "./UserResponseList";
import { useSelector } from "react-redux";
import axios from "axios";
// import { generateExcel } from "../utils/excel";

const SiteUserSingleResponse = () => {
  const navigate = useNavigate();
  const { responseId } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchQestions = async () => {
    try {
      let { data } = await axios.get(
        `${configData.config.API_URL}/api/site/response/${responseId}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setQuestions(data.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchQestions();
  }, []);
  return (
    <div className="container-fluid p-4">
      <div className="d-flex gap-2">
        <button className="backbtn cursor-pointer" title="Back" onClick={() => navigate(-1)}>
          <BackIcon />
          Back
        </button>
        <div className="breadcrums m-0">
          <span style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
            {questions.machineName}
          </span>
          <span>
            {" "}
            <RightArrowIcon />{" "}
          </span>
          <span>{questions.name}</span>
        </div>
      </div>
      <div className="d-flex gap-3" style={{ justifyContent: "flex-end" }}>

      </div> 
      <UserResponseList loading={loading} data={questions.data} fetchQestions={fetchQestions} />
    </div>
  );
};

export default SiteUserSingleResponse;
